export interface ProposedYearOption {
  DisplayName: string;
  ProposedYear: number;
  ProposedYearId: number;
}

export interface CountryOption {
  CountryMasterID: number;
  CountryKey: string;
  CountryName: string;
}

export interface CityOption {
  CityID: number;
  CityKey: string;
  CityName: string;
  CountryMasterID: number;
}

export interface ProjectDetail {
  AdditionalContractNo: string;
  City: string;
  ClientName: string;
  ContractNumber: string;
  Country: string;
  Market: string;
  MarketUnit: string;
  RepLetterProjectID: number;
  RepLetterProjectNm: string;
}

export interface LocationReviewCard {
  LocationCity: string;
  LocationCountry: string;
  LocationCountries?: string[];
  LocationCities?: string[];
  Quarter: string;
  ProposedMonth: string;
  RCManager: string;
  RCSupervisor: string;
  RCReviewer: string;
  SecondaryManager: string;
  SecondarySupervisor: string;
  SecondaryReviewer: string;
  IsParentLocation: boolean;
  ParentReviewerName: string;
  isReadonly?: boolean;
}

export interface StandardReviewForm {
  ReviewName: string;
  ProposedYear: string;
  MasterClientName: string;
  'D&TProjectName': string;
  ContractNumber: string;
  AdditionalContractNumber: string;
  Market: string;
  MarketUnit: string;
  CustomerRelationshipName: string;
  PlanName: string;
  QADRecommendation: string;
  ClientQualityCQI: string;
  ClientAccountLead: string;
  OperationAccountLead: string;
  MasterClientID: string;
  DeliveryCountry: string[];
  LocationsToReview: string[];
  Comments: string;
}

export interface ReviewDocument {
  DocSeq: number;
  DocumentType: string;
  FileName: string;
  StorageFilePath: string;
  FileSize: number;
  FileType: string;
  Description: string;
  fileContent: string;
  UploadedBy: string;
}

export type FormFieldKey = keyof StandardReviewForm;

export interface ValidationRule {
  label: string;
  type: 'input' | 'select';
}

export function createDefaultStandardReviewForm(): StandardReviewForm {
  return {
    ReviewName: '',
    ProposedYear: '',
    MasterClientName: '',
    'D&TProjectName': '',
    ContractNumber: '',
    AdditionalContractNumber: '',
    Market: '',
    MarketUnit: '',
    CustomerRelationshipName: '',
    PlanName: '',
    QADRecommendation: '',
    ClientQualityCQI: '',
    ClientAccountLead: '',
    OperationAccountLead: '',
    MasterClientID: '',
    DeliveryCountry: [],
    LocationsToReview: [],
    Comments: '',
  };
}
